(() => {
  if (window.olouiooRefreshmentCartReady) return;
  window.olouiooRefreshmentCartReady = true;
  let busy = false;

  async function openStationEditor(row, button) {
    const error = row.querySelector('[data-rfs-station-error]');
    let root = document.querySelector('[data-rfs-root]');
    const cartRoot = window.Shopify?.routes?.root || '/';
    const response = await fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(error.dataset.editErrorMessage);
    const cart = await response.json();
    const keys = JSON.parse(row.dataset.rfsStationLines).map(line => line.key);
    const group = row.dataset.rfsStationGroup;
    const items = cart.items.filter(item => String(item.product_id) === '7740771991686' && (item.properties?._olouioo_refreshment_group === group || (!item.properties?._olouioo_refreshment_group && keys.includes(item.key))));
    if (!items.length) throw new Error(error.dataset.editErrorMessage);
    const properties = items[0].properties || {};
    const source = cart.items.find(item => String(item.product_id) === properties._olouioo_source_product && String(item.variant_id) === properties._olouioo_source_variant && String(item.quantity) === properties._olouioo_source_quantity);
    if (!root) {
      const url = new URL(row.dataset.rfsEditorUrl, location.origin);
      if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
      const pageResponse = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!pageResponse.ok) throw new Error(error.dataset.editErrorMessage);
      const page = new DOMParser().parseFromString(await pageResponse.text(), 'text/html');
      const source = page.querySelector('[data-rfs-root]');
      const script = [...page.querySelectorAll('script[src]')].find(element => element.src.includes('/olouioo-refreshment-station.js'));
      if (!source || !script) throw new Error(error.dataset.editErrorMessage);
      for (const link of page.querySelectorAll('link[rel=stylesheet]')) {
        if (!link.href.includes('/olouioo-refreshment-station.css') || [...document.querySelectorAll('link[rel=stylesheet]')].some(existing => existing.href === link.href)) continue;
        document.head.append(document.importNode(link, true));
      }
      root = document.importNode(source, true);
      root.removeAttribute('data-ready');
      root.style.display = 'contents';
      root.querySelector('[data-rfs-open]').hidden = true;
      document.body.append(root);
      if (!window.OlouiooRefreshment) {
        await new Promise((resolve, reject) => {
          const loader = document.createElement('script');
          loader.src = script.src;
          loader.onload = resolve;
          loader.onerror = () => { loader.remove(); root.remove(); reject(new Error(error.dataset.editErrorMessage)); };
          document.head.append(loader);
        });
      }
    }
    window.OlouiooRefreshment?.boot();
    if (root.dataset.ready !== 'true') throw new Error(error.dataset.editErrorMessage);
    const drawer = row.closest('cart-drawer-component');
    if (drawer) {
      const dialog = drawer.querySelector('dialog');
      if (dialog?.open) await new Promise(resolve => {
        dialog.addEventListener('close', resolve, { once: true });
        drawer.closeDialog();
        if (!dialog.open) resolve();
      });
    }
    root.dispatchEvent(new CustomEvent(button.hasAttribute('data-rfs-add-station') ? 'olouioo:refreshment:copy' : 'olouioo:refreshment:edit', { detail: { group, items, source, trigger:button, returnToCart() {
      if (drawer?.isConnected) drawer.openDialog();
      else if (button.isConnected) button.focus({ preventScroll: true });
    } } }));
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-rfs-edit-station],[data-rfs-add-station]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || button.disabled) return;
    const row = button.closest('[data-rfs-station-lines]');
    const error = row.querySelector('[data-rfs-station-error]');
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try { await openStationEditor(row, button); }
    catch (failure) { error.textContent = failure.message || error.dataset.editErrorMessage; error.hidden = false; }
    finally { busy = false; button.disabled = false; button.removeAttribute('aria-busy'); }
  }, true);

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-rfs-remove-station]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || button.disabled) return;
    const row = button.closest('[data-rfs-station-lines]');
    const error = row.querySelector('[data-rfs-station-error]');
    let lines;
    try { lines = JSON.parse(row.dataset.rfsStationLines); } catch { return; }
    if (!Array.isArray(lines) || !lines.length || lines.some(line => typeof line.key !== 'string' || !line.key)) return;
    busy = true;
    error.hidden = true;
    row.setAttribute('aria-busy', 'true');
    const controls = [...document.querySelectorAll('cart-items-component button,cart-items-component input,cart-items-component select')].map(control => [control, control.disabled]);
    controls.forEach(([control]) => { control.disabled = true; });
    button.disabled = true;
    let announcement;
    try {
      const events = await import('@theme/standard-cart-events');
      const { CartUpdateEvent } = await import('@theme/events');
      const components = [...document.querySelectorAll('cart-items-component')];
      const sections = [...new Set(components.map(component => component.dataset.sectionId).filter(Boolean))];
      const announcementBar = document.querySelector('announcement-bar:has(free-shipping-bar)');
      if (announcementBar?.dataset.sectionId) sections.push(announcementBar.dataset.sectionId);
      const cartUrl = row.closest('form')?.getAttribute('action') || window.Theme?.routes?.cart_url || '/cart';
      announcement = events.announceCartLinesUpdate(row, { action: 'remove', context: 'cart', lines: lines.map(line => ({ id: line.key, quantity: 0 })) });
      const response = await fetch(cartUrl.replace(/\/$/, '') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: Object.fromEntries(lines.map(line => [line.key, 0])), sections: sections.slice(0, 5), sections_url: location.pathname }) });
      const cart = await response.json();
      if (!response.ok || cart.status || cart.errors) throw new Error(typeof cart.description === 'string' ? cart.description : error.dataset.errorMessage);
      const component = row.closest('cart-items-component');
      (component || document).dispatchEvent(new CartUpdateEvent({}, component?.dataset.sectionId, { source: 'refreshment-station-remove', items: cart.items, itemCount: cart.item_count, sections: cart.sections, autoOpenDrawer: false }));
      events.settleWithCart(announcement, cart, { source: 'refreshment-station-remove', sections: cart.sections });
    } catch (failure) {
      announcement?.reject(failure);
      error.textContent = failure.message || error.dataset.errorMessage;
      error.hidden = false;
    } finally {
      busy = false;
      row.removeAttribute('aria-busy');
      controls.forEach(([control, disabled]) => { control.disabled = disabled; });
      button.disabled = false;
    }
  }, true);
})();

